import { Document } from "@tiptap/extension-document";

const CustomDocument = Document.extend({
  content: "title excerpt section*",

  addKeyboardShortcuts() {
    return {
      Escape: () => {
        return this.editor
          .chain()
          .focus()
          .setTextSelection({
            from: this.editor.state.selection.from,
            to: this.editor.state.selection.from,
          })
          .run();
      },
    };
  },
});

export default CustomDocument;
